import { Refresh } from "@mui/icons-material";
import { IconButton, LinearProgress, TableCell, TableRow } from "@mui/material";
import { displayDocumentStatus } from "Backend";
import { DocumentIntake, DocumentStatus } from "generated/graphql";
import formatSizeBytes from "helpers/formatSizeBytes";
import { ReactNode, useState } from "react";
import { EllipsisSX } from "theme";
import ReprocessDocumentsDialog from "./ReprocessDocumentsDialog";
import { formatTimeAgoNoSeconds } from "helpers/formatTimeAgo";
import { type DocumentSegmentStaged } from "redux/slices/case";

interface DocumentSegmentRowProps {
  segment: DocumentSegmentStaged;
  intake: DocumentIntake;
  caseId: number;
}

const renderSegmentStatus = (segment: DocumentSegmentStaged): ReactNode => {
  const details = segment.processingDetails;
  if (segment.status === DocumentStatus.Processing && details) {
    return <LinearProgress variant="determinate" value={(details.stageNumber / details.stageTotal) * 100} />;
  } else return displayDocumentStatus(segment.status);
};

const DocumentSegmentRow = (props: DocumentSegmentRowProps) => {
  const { segment, intake, caseId } = props;
  const [reprocess, setReprocess] = useState<boolean>(false);
  const processedOn = segment.processedAt ? formatTimeAgoNoSeconds(new Date(segment.processedAt)) : undefined;
  return (
    <>
      <TableRow>
        <TableCell>{/* This cell is just filler */}</TableCell>
        <TableCell align="center">
          <IconButton size="small" onClick={() => setReprocess(true)}>
            <Refresh />
          </IconButton>
        </TableCell>
        <TableCell sx={EllipsisSX}>
          {intake.name} - {segment.partIndex}
        </TableCell>
        <TableCell>{segment.id}</TableCell>
        {/* upload date */}
        <TableCell></TableCell>
        {/* processed on */}
        <TableCell>{processedOn}</TableCell>
        <TableCell>{formatSizeBytes(segment.sizeBytes)}</TableCell>
        <TableCell>
          {segment.startPage} - {segment.startPage + segment.pageCount - 1}
        </TableCell>
        {/* read quality */}
        <TableCell></TableCell>
        {/* status */}
        <TableCell>{renderSegmentStatus(segment)}</TableCell>
      </TableRow>
      {reprocess && (
        <ReprocessDocumentsDialog
          open={reprocess}
          close={() => setReprocess(false)}
          documentId={segment.id}
          caseId={caseId}
        />
      )}
    </>
  );
};

export default DocumentSegmentRow;
